var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-highcharts',{ref:"chartBudgetSecure",attrs:{"options":_vm.obj_chart.docStatisticOption}})}
var staticRenderFns = []

export { render, staticRenderFns }